import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ArchiveOutlineIcon = ({ color, ...rest }: { color?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorText;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...rest}>
      <path
        fill={currentColor}
        fillRule="evenodd"
        d="M15 0c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h14zM5.012 6H3.625c-.332 0-.636.185-.79.48L1.1 9.822c-.066.127-.1.267-.1.41v3.878c0 .491.398.889.889.889H14.11c.491 0 .889-.398.889-.889v-3.89c0-.135-.03-.268-.09-.39l-1.63-3.333c-.149-.305-.459-.498-.798-.498H11.01l2.025 4.016h-2.212C10.407 11.173 9.3 12 8 12c-1.3 0-2.407-.827-2.824-1.984H2.987L5.012 6zm4.991-4.992H6.01v3H4L8 7l4-2.992h-1.997v-3z"
      />
    </svg>
  );
};

export default ArchiveOutlineIcon;
